import * as yup from 'yup'

const schemaCompanyDestroy = () =>
  yup.object().shape({
    description: yup.string().required(),
  })

export default schemaCompanyDestroy
